// @flow
import React from 'react';
import Group from 'sail/Group';
import {ServerSetting} from './components/ServerSetting';

export const SERVER_ONLY_SETTINGS = {
  servers: ['ruby', 'node', 'php', 'python', 'go', 'dotnet', 'java'],
};

export const ServerOnlySettings = () => {
  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <ServerSetting servers={SERVER_ONLY_SETTINGS.servers} />
    </Group>
  );
};
